module.exports = __webpack_public_path__ + "static/media/default-skin.b257fa9c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/photoswipe/dist/default-skin/default-skin.svg
// module id = 16
// module chunks = 0